module.exports = __webpack_public_path__ + "media/images/seta-azul-cima-1b1c8f4d330dff65907c127dc0e49b29.svg";